import { ZudokuPlugin } from "zudoku";

// Get PostHog configuration from environment variables
const POSTHOG_KEY = process.env.POSTHOG_KEY || process.env.NEXT_PUBLIC_POSTHOG_KEY || 'phc_ptBi6V0u37tqq9hAg5rYZJG3BKf4VktSOHaqaQPcWb8';
const POSTHOG_HOST = process.env.POSTHOG_HOST || process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com';

const posthogPlugin: ZudokuPlugin = {
  // Add PostHog script to page head
  getHead: () => {
    // Only initialize PostHog if we have a valid key
    if (!POSTHOG_KEY || POSTHOG_KEY === 'your-posthog-project-key') {
      return null;
    }

    return (
      <script>
        {`!function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init hi $r kr ui wr Er capture Ri calculateEventProperties Ir register register_once register_for_session unregister unregister_for_session Fr getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey canRenderSurvey canRenderSurveyAsync identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty Cr Tr createPersonProfile Or yr Mr opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing Pr debug L Rr getPageViewId captureTraceFeedback captureTraceMetric gr".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
posthog.init('${POSTHOG_KEY}', {
    api_host: '${POSTHOG_HOST}',
    defaults: '2025-05-24',
    person_profiles: 'identified_only',
});`}
      </script>
    );
  },

  // Handle SPA navigation events for PostHog page view tracking
  events: {
    location: ({ from, to }) => {
      // Skip initial page load (PostHog handles this automatically)
      if (!from) return;

      // Track page view for SPA navigation with site_name for differentiation
      if (window.posthog) {
        window.posthog.capture("$pageview", {
          $current_url: window.location.href,
          site_name: "relay.works/docs",
        });
      }
    },
  },
};

// Type declaration for global PostHog
declare global {
  interface Window {
    posthog?: any;
  }
}

export default posthogPlugin;
